import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=fee57216&scoped=true"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
import style0 from "./Room.vue?vue&type=style&index=0&id=fee57216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee57216",
  null
  
)

export default component.exports